export default "__VITE_ASSET__07c567c2__"